module.exports = __webpack_public_path__ + "img/zbAbout.86115ca7.jpg";